<template>
    <b-row class="mt-3 answers">
        <b-col>
            <slot name="alert"/>

            <div v-if="isStateAllowed && show_all"
                 v-for="(question_group, index) in question_groups"
            >
                <div v-show="index === questions_index">
                    <h6 class="mb-4" v-if="question_group.name">{{ (index + 1) }}. {{ question_group.name }}</h6>

                    <table class="table table-hover d-none d-md-table"
                           v-if="!!question_group.questions.length"
                    >
                        <thead>
                        <tr class="font-weight-bold text-white bg-soluquim">
                            <th v-if="showClass">CLASE</th>
                            <th v-if="showCategory" style="max-width: 200px">CATEGORÍA</th>
                            <th></th>
                            <th colspan="2">RESPUESTA</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(question) in question_group.questions">
                            <td v-if="showClass">
                            <span v-if="question.danger_class">
                                {{ question.danger_class.name }}
                            </span>
                            </td>
                            <td v-if="showCategory">{{ question.sub_category || question.category }}</td>
                            <td>
                                <slot v-if="hasSlot(question.code)"
                                      :name="question.code"
                                      v-bind:data="question"
                                />
                                <span v-else
                                      v-html="formattedQuestion(question.question)"
                                />

                                <el-popover v-if="question.help_text"
                                            placement="left"
                                            title="Ayuda"
                                            width="500"
                                            trigger="click"
                                            popper-class="custom-popover"
                                >
                                    <div v-html="getHelpText(question.help_text)"/>
                                    <span slot="reference"
                                          style="cursor: pointer"
                                          class="font-weight-bold text-success text-nowrap"
                                    >
                                    <i class="fa fa-info-circle text-success ml-3"/> Ayuda
                                </span>
                                </el-popover>
                            </td>
                            <td v-if="question.type === 'check'">
                                <slot v-if="hasSlot('answer_true_'  + question.code)"
                                      :name="'answer_true_'  + question.code"
                                      v-bind:data="question"
                                />
                                <b-form-radio v-else
                                              v-model="question.answer"
                                              class="radio_true"
                                              :value="true"
                                              :state="true"
                                              @change="changeResponse(question)"
                                              :disabled="disabledInputs(question)"
                                >
                                    Si
                                </b-form-radio>
                            </td>
                            <td v-if="question.type === 'check'">
                                <slot v-if="hasSlot('answer_false_'  + question.code)"
                                      :name="'answer_false_'  + question.code"
                                      v-bind:data="question"
                                />
                                <b-form-radio v-else
                                              v-model="question.answer"
                                              class="radio_false"
                                              :value="false"
                                              :state="false"
                                              @change="changeResponse(question)"
                                              :disabled="disabledInputs(question)"
                                >
                                    No
                                </b-form-radio>
                            </td>
                            <td v-else-if="question.type === 'number'"
                                colspan="2"
                            >
                                <el-input type="number"
                                          size="small"
                                          v-model="question.answer"
                                          @input="onInput(question)"
                                          @focus="selectAllText"
                                          :disabled="disabledInputs(question)"
                                          placeholder="Diligencie la información"
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <table class="table table-sm d-table d-md-none"
                           v-if="!!question_group.questions.length"
                    >
                        <tbody>
                        <template v-for="(question, index_question) in question_group.questions">
                            <tr>
                                <td class="font-weight-bold">CLASE</td>
                                <td>
                                <span v-if="question.danger_class">
                                    {{ question.danger_class.name }}
                                </span>
                                </td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold">CATEGORÍA</td>
                                <td>{{ question.sub_category || question.category }}</td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold">PREGUNTA</td>
                                <td>
                                    <slot v-if="hasSlot(question.code)"
                                          :name="question.code"
                                          v-bind:data="question"
                                    />
                                    <span v-else
                                          v-html="formattedQuestion(question.question)"
                                    />

                                    <el-popover v-if="question.help_text"
                                                placement="left"
                                                title="Ayuda"
                                                width="500"
                                                trigger="click"
                                                popper-class="custom-popover"
                                    >
                                        <div v-html="getHelpText(question.help_text)"/>
                                        <span slot="reference"
                                              style="cursor: pointer"
                                              class="font-weight-bold text-success text-nowrap"
                                        >
                                        <i class="fa fa-info-circle text-success ml-3"/> Ayuda
                                    </span>
                                    </el-popover>
                                </td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold border-table">RESPUESTA</td>
                                <td v-if="question.type === 'check'"
                                    class="border-table"
                                >
                                    <slot v-if="hasSlot('answer_true_'  + question.code)"
                                          :name="'answer_true_'  + question.code"
                                          v-bind:data="question"
                                    />
                                    <b-form-radio v-else
                                                  v-model="question.answer"
                                                  class="radio_true"
                                                  :value="true"
                                                  :state="true"
                                                  @change="changeResponse(question)"
                                                  :disabled="disabledInputs(question)"
                                    >
                                        Si
                                    </b-form-radio>

                                    <slot v-if="hasSlot('answer_false_'  + question.code)"
                                          :name="'answer_false_'  + question.code"
                                          v-bind:data="question"
                                    />
                                    <b-form-radio v-else
                                                  v-model="question.answer"
                                                  class="radio_false"
                                                  :value="false"
                                                  :state="false"
                                                  @change="changeResponse(question)"
                                                  :disabled="disabledInputs(question)"
                                    >
                                        No
                                    </b-form-radio>
                                </td>
                                <td v-else-if="question.type === 'number'"
                                    class="border-table"
                                >
                                    <el-input type="number"
                                              size="small"
                                              v-model="question.answer"
                                              @input="onInput(question)"
                                              @focus="selectAllText"
                                              :disabled="disabledInputs(question)"
                                              placeholder="Diligencie la información"
                                    />
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>

                    <b-row
                        v-if="!question_group.questions.length && (!classification.sga_categories.length || classification.index_questions !== questions_index)">
                        <b-col>
                            <b-alert variant="success"
                                     show
                            >
                                NO CUMPLE LOS CRITERIOS DE CLASIFICACIÓN POR INTERPOLACIÓN DE MEZCLAS
                            </b-alert>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="text-center">
                            <b-button variant="info"
                                      size="sm"
                                      class="mx-1"
                                      v-if="questions_index > 0"
                                      @click="prev"
                            >
                                <i class="fa fa-arrow-left"/> Anterior
                            </b-button>

                            <b-button variant="secondary"
                                      size="sm"
                                      class="mx-1"
                                      @click="next"
                                      v-if="showNext()"
                            >
                                Siguiente <i class="fa fa-arrow-right"/>
                            </b-button>

                            <b-button variant="primary"
                                      size="sm"
                                      class="mx-1"
                                      @click="_saveAnswers(true)"
                                      v-if="showSave(index)"
                            >
                                Guardar <i class="fa fa-save"/>
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>

            <classification :classification.sync="classification"
                            :questions_index="questions_index"
                            v-if="show_classification"
            />
        </b-col>
    </b-row>
</template>

<script>

import Classification from './classification.vue';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import {Notification} from 'element-ui';

export default {
    name: 'index',
    components: {
        Classification
    },
    props: {
        unique_category: {
            required: false,
            default: false
        },
        code_question_group: {
            required: true,
        },
        danger_code: {
            required: true
        },
        control_question: {
            required: false,
            default: ''
        },
        control_answer: {
            required: false,
            default: null
        },
        show_save: {
            required: false,
            default: true
        },
        show_next: {
            required: false,
            default: true
        },
        show_classification: {
            required: false,
            default: true
        },
        disable_answers: {
            required: false,
            type: Function,
            default: () => {
            }
        }
    },
    data() {
        return {
            show_all: false,
            filtered_categories: [],
            typing_timer: null,
            done_typing_interval: 1000,
            changing_response: false
        };
    },
    computed: {
        ...mapState('calculator', [
            'question_groups',
            'index_to_show',
            'classification',
            'product',
            'answers',
            'dangers',
            'categories',
            'danger_classes',
            'danger_categories',
            'only_view',
            'questions_index'
        ]),
        ...mapGetters('calculator', [
            'isStateAllowed'
        ]),
        categoryClassification() {
            if (this.unique_category) {
                return this.classification.category;
            }

            return null;
        },
        showClass() {
            const question_group = this.question_groups[this.questions_index];

            if (question_group) {
                return question_group.questions.some(q => !!q.danger_class);
            }

            return true;
        },
        showCategory() {
            const question_group = this.question_groups[this.questions_index];

            if (question_group) {
                return question_group.questions.some(q => !!q.category);
            }

            return true;
        },
        hasClassificationOptions() {
            let next = false

            if (this.classification.category) {
                this.question_groups.forEach((qg, i) => {
                    if (i > this.questions_index) {
                        qg.questions.forEach(q => {
                            if (!next) {
                                next = q.category === this.classification.category;
                            }
                        })
                    }
                })
            }

            return next;
        },
    },
    async mounted() {
        this.show_all = false;
        this.resetClassification();
        this.setDangerCode(this.danger_code);
        this.setQuestionsIndex(0);
        await this.getQuestionGroups();
        this.setCodeQuestionGroup(this.code_question_group);
        this.filterCategories();
        await this._getClassification();

        if (this.danger_code === 'MCAL27') {
            await this.findComponentsByCASNumbers();
        }

        this.show_all = true;

        this.$emit('ready');
    },
    methods: {
        ...mapActions('calculator', [
            'getAnswers',
            'saveAnswer',
            'saveAnswers',
            'getClassification',
            'getQuestionGroups',
            'findComponentsByCASNumbers'
        ]),
        ...mapMutations('calculator', [
            'clearAnswers',
            'setDangerCode',
            'setQuestionsIndex',
            'setClassification',
            'resetClassification',
            'setCodeQuestionGroup',
            'setQuestionGroupsWithAnswers',
            'setQuestionsIndexFromClassification'
        ]),
        showNext() {
            return this.show_next &&
                +this.questions_index < (this.question_groups.length - 1) &&
                ((!this.classification.sga_categories.length) || (this.classification.sga_categories.length && this.hasClassificationOptions))
        },
        showSave(index) {
            return this.show_save &&
                !this.only_view &&
                (this.classification.sga_categories.length ||
                    this.classification.index_questions === this.questions_index ||
                    index === (this.question_groups.length - 1))
        },
        disabledInputs(question) {
            if (this.only_view || question.disabled) return true;

            if (!!this.categoryClassification && this.categoryClassification != question.category) return true;

            if (this.control_question && question.code !== this.control_question) {
                const question_group = this.question_groups[this.questions_index];

                const questions = question_group.questions;

                const control_question = questions.find(q => q.code === this.control_question && q.answer === this.control_answer);

                return !control_question;
            }

            return false;
        },
        formattedQuestion(question) {
            return question.replace(/\n/g, '<hr class="my-1">');
        },
        getHelpText(text) {
            return text.replace(/\n/g, '<br>');
        },
        async onInput(question) {
            clearTimeout(this.typing_timer);
            this.typing_timer = setTimeout(async () => {
                try {
                    if (this.changing_response) return;
                    this.changing_response = true;
                    await this.changeResponse(question);
                    this.changing_response = false;
                } catch (e) {
                    this.changing_response = false;
                }
            }, this.done_typing_interval);
        },
        selectAllText(event) {
            event.target.select();
        },
        async changeResponse(question) {
            await this.saveAnswer(question);

            this.disable_answers(this.questions_index);
        },
        filterCategories() {
            let filtered_categories = [];

            this.categories.map(c => {
                c.options.map(o => {
                    filtered_categories.push(o);
                });
            });

            this.filtered_categories = filtered_categories;
        },
        classify(danger_class_code, danger_category_code, sga_categories, sga_subcategory_code = null) {
            this.resetClassification();

            let classification = JSON.parse(JSON.stringify(this.classification));

            let danger_class = this.danger_classes.find(dc => dc.code === danger_class_code);
            let danger = this.dangers.find(m => m.code === this.danger_code);

            classification.classified = 0;
            classification.cal_product_id = this.product.id;
            classification.danger = danger;
            classification.cal_danger_id = danger.id;
            classification.index_questions = this.questions_index;
            classification.category = danger_category_code;
            classification.sub_category = sga_subcategory_code;

            if (danger_class && danger) {
                classification.classified = 1;
                classification.danger_class = danger_class;
                classification.cal_danger_class_id = danger_class.id;
                classification.sga_categories = sga_categories;
                classification.pictogram_sga = {};
                classification.pictogram_sga_id = null;
                classification.pictogram_un = {};
                classification.pictogram_un_id = null;
            }

            this.setClassification(classification);
        },
        async _getClassification() {
            await this.getClassification({
                product_id: this.product.id,
                danger_code: this.danger_code,
                code_question_group: this.code_question_group
            });
        },
        async prev() {
            this.setQuestionsIndex(this.questions_index - 1);
            await this._saveAnswers();
        },
        async next() {
            this.setQuestionsIndex(this.questions_index + 1);
            await this._saveAnswers();
        },
        async _saveAnswers(show_message = false) {
            await this.saveAnswers(this.questions_index);

            if (show_message) {
                Notification.success({
                    title: 'Muy bien',
                    message: 'Respuestas guardadas exitosamente',
                    type: 'success',
                    duration: 2000
                });
            }
        },
        hasSlot(name = 'default') {
            return !!this.$slots[name] || !!this.$scopedSlots[name];
        }
    }
};
</script>

<style lang="scss">
.custom-popover {
    width: 500px;
    word-wrap: break-word;
    white-space: normal;
    word-break: break-word;
}

.border-table {
    border-bottom: 3px solid #1a94c0;
}

.answers {
    .table {
        border-collapse: separate;
        border-spacing: 0;
    }

    .table thead tr:first-child th:first-child {
        border-top-left-radius: 0.3rem;
    }

    .table thead tr:first-child th:last-child {
        border-top-right-radius: 0.3rem;
    }

    .table td,
    .table th {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
    }
}
</style>
